<template>
  <div class="not-found-page">
    <div class="not-found-content">
      <div class="not-found-icon">
        <i class="el-icon-warning-outline"></i>
      </div>
      <h1 class="not-found-title">404</h1>
      <p class="not-found-desc">页面不存在或已被移除</p>
      <el-button type="primary" class="btn-gold" @click="goHome">
        <i class="el-icon-back"></i> 返回首页
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  methods: {
    goHome() {
      const role = this.$store.state.user && this.$store.state.user.role
      if (role === 'manager') {
        this.$router.push('/')
      } else {
        this.$router.push('/admin/tasks')
      }
    }
  }
}
</script>

<style scoped>
.not-found-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-bg);
}

.not-found-content {
  text-align: center;
  padding: var(--space-3xl);
}

.not-found-icon {
  font-size: 64px;
  color: var(--color-primary);
  margin-bottom: var(--space-lg);
}

.not-found-title {
  font-size: 72px;
  font-weight: 700;
  color: var(--color-accent);
  margin: 0 0 var(--space-md) 0;
  line-height: 1;
}

.not-found-desc {
  font-size: 16px;
  color: var(--color-text-secondary);
  margin-bottom: var(--space-xl);
}

.btn-gold {
  background: var(--color-primary);
  color: var(--color-accent);
  border: none;
  border-radius: var(--radius-md);
  padding: 10px 24px;
  font-weight: 600;
}

.btn-gold:hover {
  background: var(--color-primary-light);
}
</style>
